import type { RenderElementProps } from 'slate-react';

import BulletedListElement from './elements/BulletedListElement';
import HeadingFive from './elements/HeadingFive';
import HeadingFour from './elements/HeadingFour';
import HeadingThree from './elements/HeadingThree';
import HeadingTwo from './elements/HeadingTwo';
import LinkElement from './elements/LinkElement';
import ListItemElement from './elements/ListItemElement';
import ParagraphElement from './elements/ParagraphElement';

type RenderElementType = {
  id?: string;
} & RenderElementProps;

const RenderElement = (props: RenderElementType) => {
  const { attributes, children, element, id } = props;
  switch (element.type) {
    case 'heading-two': {
      return (
        <HeadingTwo id={id} element={element}>
          {children}
        </HeadingTwo>
      );
    }
    case 'heading-three': {
      return (
        <HeadingThree id={id} element={element}>
          {children}
        </HeadingThree>
      );
    }
    case 'heading-four': {
      return (
        <HeadingFour id={id} element={element}>
          {children}
        </HeadingFour>
      );
    }
    case 'heading-five': {
      return (
        <HeadingFive id={id} element={element}>
          {children}
        </HeadingFive>
      );
    }
    case 'link': {
      return (
        <LinkElement id={id} element={element}>
          {children}
        </LinkElement>
      );
    }
    case 'bulleted-list': {
      return (
        <BulletedListElement id={id} element={element}>
          {children}
        </BulletedListElement>
      );
    }
    case 'list-item': {
      return (
        <ListItemElement id={id} element={element}>
          {children}
        </ListItemElement>
      );
    }
    case 'numbered-list': {
      return (
        <ol id={id} {...attributes}>
          {props.children}
        </ol>
      );
    }
    default:
      return (
        <ParagraphElement id={id} element={element}>
          {children}
        </ParagraphElement>
      );
  }
};

export default RenderElement;
